export const environment = {
  production: false,
  console: true,
  API_URL: "https://apipre.apiacpos.com/2_15_0_bridge/api/",
  CODIGO_APLICACION: "CUSTOMAN",
  ID_APLICACION: "19",
  chClaveEmpresa: "CAMACOL",
  TICKETS_URL: "https://tickamore.webventa.iacpospre.com/camacol",
  chProyectoOnLine: "VENTAONLINE",
  chEntornoConexion: "DESARROLLO",
  chNombreProyecto: "CUSTOMMAN",
  chOrigenConexion: "CUSTOMMAN",
  NUMSERIE: "CUSTO$A$SZ45$A$MMAN$A$23g!.",
  API_MICROSERVICIOS: "https://apipre.apiacpos.com/WEBAPICoreBridge_1_7_0",
  VALIDATE_PERMISSIONS: false,
};
